export default "__VITE_ASSET__qRRXC3wN__"